export default __webpack_public_path__ + "static/media/CLIENTS.cdd3269c.svg";